import { useState } from "react";
import { useRef } from "react";
import { Link, useLocation } from "react-router-dom";
import { shuffleArray } from "../../../../utils";
import RedLightGreenLightImage from "./resources/jd1bg.png";
import video from "./resources/game1vid.mp4";
import audiobgm from "./resources/rlgl_bgm.mp3";
import { ReactComponent as CircleSvg } from "../../../../SharedImages/Circle.svg";
import { ReactComponent as SkullSvg } from "../../../../SharedImages/Skull.svg";
import "./RedLightGreenLightPage.css";
import { useEffect } from "react";
import { GAME_OPTIONS_PATH, API_BASE_URL } from "../../../../constants";
import { updateProgress, useVocabUnitData } from "../../../../database";
import { FIREBASE_AUTH } from "../../../../FirebaseConfig";
import { onAuthStateChanged } from "firebase/auth";
import AudioControls from "../../GameComponents/AudioControls";

function ScoreView() {
  return (
    <>
      <CircleSvg />
      <CircleSvg />
      <SkullSvg />
    </>
  );
}

function RedLightGreenLightPage() {
  const videoRef = useRef();
  const handlePlay = () => {
    if (videoRef.current) {
      videoRef.current.play();
    }
  };
  const handlePause = () => {
    if (videoRef.current) {
      videoRef.current.pause();
    }
  };
  const RED = "#B81D13";
  const GREEN = "#008450";
  const EASY_QUESTION_RESPONSE_TIME = 12000;
  const MEDIUM_QUESTION_RESPONSE_TIME = 8000;
  const HARD_QUESTION_RESPONSE_TIME = 5000;
  const RED_LIGHT_PAUSE_TIME = 2500;

  //
  const location = useLocation();
  const {unit, category} = location.state;

  const { data: vocabData, loading, error } = useVocabUnitData(unit.unit, unit.textbook);
  var questions = vocabData;

  useEffect(() => {
    if (!loading && vocabData.length > 0) {
      questions = vocabData;
    }
    console.log(questions);
  }, [vocabData, loading]);
  // Game state
  const [questionResponseTime, setQuestionResponseTime] = useState(5000);
  const [currQuestionIndex, setCurrQuestionIndex] = useState(0);
  const [currCorrectScore, setCurrCorrectScore] = useState(-1); // set as -1 so update to 1 in startGame() triggers rerender
  const [currIncorrectScore, setCurrIncorrectScore] = useState(0);
  const [questionLanguage, setQuestionLanguage] = useState("");
  const [answerLanguage, setAnswerLanguage] = useState("");
  const [state, setState] = useState({
    questions: [],
  });

  const [showErrorMessage, setShowErrorMessage] = useState(false);
  const [showCorrectMessage, setCorrectMessage] = useState(false);

  const [user, setUser] = useState(null);
  
  const audioRefBgm = useRef(null);
  const [volume, setVolume] = useState(0.5);
  const [isMuted, setIsMuted] = useState(false);

  useEffect(() => {
    if (audioRefBgm.current) {
        audioRefBgm.current.volume = isMuted ? 0 : volume;
    }
  }, [volume, isMuted]);

  useEffect(() => {
    onAuthStateChanged(FIREBASE_AUTH, (user) => {
      setUser(user);
    });
  });

  useEffect(() => {
    if (!loading && vocabData.length > 0) {
      setState((prevState) => {
        if (JSON.stringify(prevState.questions) !== JSON.stringify(vocabData)) {
          return {
            ...prevState,
            questions: vocabData,
          };
        }
        return prevState;
      });
    }
  }, [vocabData, loading]);

  function openTutorial() {
    const pregameEl = document.getElementById("pregame-div");
    const tutorialEl = document.getElementById("tutorial");
    const postgameEl = document.getElementById("postgame-div");
    const gameEl = document.getElementById("game-div");

    if (pregameEl) pregameEl.style.display = "none";
    if (tutorialEl) tutorialEl.style.display = "flex";
    if (postgameEl) postgameEl.style.display = "none";
    if (gameEl) gameEl.style.display = "none";
  }

  function closeTutorial() {
    const pregameEl = document.getElementById("pregame-div");
    const tutorialEl = document.getElementById("tutorial");
    const postgameEl = document.getElementById("postgame-div");

    if (pregameEl) pregameEl.style.display = "flex";
    if (tutorialEl) tutorialEl.style.display = "none";
    if (postgameEl) postgameEl.style.display = "none";
  }

  function startGame() {
    const difficultyRadioButton = document.querySelector(
      'input[name="difficulty"]:checked'
    );
    const answerLanguageRadioButton = document.querySelector(
      'input[name="answer-language"]:checked'
    );
    
    if (!difficultyRadioButton || !answerLanguageRadioButton) {
      alert("Please select both difficulty level and answer language");
      return;
    }
    
    const difficulty = difficultyRadioButton.value;
    setAnswerLanguage(
      answerLanguageRadioButton.value === "korean" ? "korean" : "englishLiterals"
    );
    setQuestionLanguage(
      answerLanguageRadioButton.value === "korean" ? "english" : "korean"
    );
    // const answerType = document.querySelector('input[name="answer-type"]:checked').value;

    if (difficulty === "easy") {
      setQuestionResponseTime(EASY_QUESTION_RESPONSE_TIME);
    } else if (difficulty === "medium") {
      setQuestionResponseTime(MEDIUM_QUESTION_RESPONSE_TIME);
    } else {
      setQuestionResponseTime(HARD_QUESTION_RESPONSE_TIME);
    }
    shuffleArray(state.questions);
    setCurrCorrectScore(1);
    setCurrIncorrectScore(0);
    setCurrQuestionIndex(0);
    
    const scoreViewEl = document.getElementById("score-view");
    if (scoreViewEl) {
      for (let i = 0; i < 3; i++) {
        if (scoreViewEl.childNodes[i]) {
          scoreViewEl.childNodes[i].classList.remove("red");
        }
      }
    }

    if (audioRefBgm.current) {
        audioRefBgm.current.playbackRate = 5000 / (difficulty === "easy" ? EASY_QUESTION_RESPONSE_TIME : (difficulty === "medium" ? MEDIUM_QUESTION_RESPONSE_TIME : HARD_QUESTION_RESPONSE_TIME));
        audioRefBgm.current.currentTime = 0;
        audioRefBgm.current.play().catch((err) => console.log("Audio autoplay blocked:", err));
    }

    const pregameEl = document.getElementById("pregame-div");
    const tutorialEl = document.getElementById("tutorial");
    const postgameEl = document.getElementById("postgame-div");
    const winTextEl = document.getElementById("win-text");
    const loseTextEl = document.getElementById("lose-text");
    const gameEl = document.getElementById("game-div");
    
    if (pregameEl) pregameEl.style.display = "none";
    if (tutorialEl) tutorialEl.style.display = "none";
    if (postgameEl) postgameEl.style.display = "none";
    if (winTextEl) winTextEl.style.display = "none";
    if (loseTextEl) loseTextEl.style.display = "none";
    if (gameEl) gameEl.style.display = "flex";
    const helpButtonEl = document.getElementById("rlgl-help-button");
    if (helpButtonEl) helpButtonEl.style.display = "none";
  }

  function playAgain() {
    const pregameEl = document.getElementById("pregame-div");
    const tutorialEl = document.getElementById("tutorial");
    const postgameEl = document.getElementById("postgame-div");
    
    if (pregameEl) pregameEl.style.display = "flex";
    if (tutorialEl) tutorialEl.style.display = "none";
    if (postgameEl) postgameEl.style.display = "none";
    if (audioRefBgm.current) audioRefBgm.current.pause();
    const helpButtonEl = document.getElementById("rlgl-help-button");
    if (helpButtonEl) helpButtonEl.style.display = "flex";
  }

  // Hook for repeating questionResponseTime second timer to answer question
  useEffect(() => {
    const prevScoreTotal = currCorrectScore + currIncorrectScore;
    const interval = setInterval(() => {
      const gameDivEl = document.getElementById("game-div");
      if (gameDivEl && gameDivEl.style.display === "flex") {
        // only execute when game is active
        if (prevScoreTotal === currCorrectScore + currIncorrectScore) {
          setShowErrorMessage(true);
          handlePlay();
          const lightEl = document.getElementById("light");
          if (lightEl) lightEl.style.backgroundColor = RED;
          
          const scoreViewEl = document.getElementById("score-view");
          if (scoreViewEl && scoreViewEl.childNodes[currIncorrectScore]) {
            scoreViewEl.childNodes[currIncorrectScore].classList.add("red");
          }
          
          const questionDivEl = document.getElementById("question-div");
          if (questionDivEl) questionDivEl.style.display = "none";
          
          setCurrIncorrectScore(currIncorrectScore + 1);
          if (user) {
            updateProgress(
              user.email,
              unit.unit,
              unit.textbook, 
              "redlightgreenlight",
              false
            );
          }
          if (audioRefBgm.current) audioRefBgm.current.pause();

          // No answer but game not over; pause on red light before next question
          setTimeout(() => {
            setShowErrorMessage(false);
            handlePause();
            const lightEl = document.getElementById("light");
            if (lightEl) lightEl.style.backgroundColor = GREEN;
            setCurrQuestionIndex(
              (currQuestionIndex + 1) % state.questions.length
            );
            const questionDivEl = document.getElementById("question-div");
            if (questionDivEl) questionDivEl.style.display = "flex";

            if (currIncorrectScore === 2) {
              const gameDivEl = document.getElementById("game-div");
              const postgameDivEl = document.getElementById("postgame-div");
              const loseTextEl = document.getElementById("lose-text");
              if (gameDivEl) gameDivEl.style.display = "none";
              if (postgameDivEl) postgameDivEl.style.display = "flex";
              if (loseTextEl) loseTextEl.style.display = "flex";
              if (audioRefBgm.current) audioRefBgm.current.pause();
            } else {
              if (audioRefBgm.current) {
                audioRefBgm.current.currentTime = 0;
                audioRefBgm.current.play().catch((err) => console.log("Audio autoplay blocked:", err));
              }
            }
          }, RED_LIGHT_PAUSE_TIME);
        }
      }
    }, questionResponseTime);
    return () => clearInterval(interval);
  }, [
    currQuestionIndex,
    currCorrectScore,
    currIncorrectScore,
    questionResponseTime,
    state.questions.length,
  ]); // if one of these changes, then the interval will be reset

  function submitAnswer() {
    // getProgress(unit.unit)[1].rlgl++
    const answerInputEl = document.getElementById("answer-input");
    if (!answerInputEl) return;
    
    const submission = answerInputEl.value;
    answerInputEl.value = "";
    let correctAnswers = state.questions[currQuestionIndex][answerLanguage];
    console.log(correctAnswers);
    if (!Array.isArray(correctAnswers)) {
      correctAnswers = [correctAnswers];
    }

    if (correctAnswers.includes(submission)) {
      setCurrCorrectScore(currCorrectScore + 1);
      if (user) {
        updateProgress(user.email, unit.unit, unit.textbook, "redlightgreenlight", true);
      }

      setCorrectMessage(true);
      if (currCorrectScore === 5) {
        const gameDivEl = document.getElementById("game-div");
        const postgameDivEl = document.getElementById("postgame-div");
        const winTextEl = document.getElementById("win-text");
        if (gameDivEl) gameDivEl.style.display = "none";
        if (postgameDivEl) postgameDivEl.style.display = "flex";
        if (winTextEl) winTextEl.style.display = "flex";
        if (audioRefBgm.current) audioRefBgm.current.pause();
      } else {
        if (audioRefBgm.current) {
          audioRefBgm.current.currentTime = 0;
          audioRefBgm.current.play().catch((err) => console.log("Audio autoplay blocked:", err));
        }
      }
      setTimeout(() => {
        setCorrectMessage(false);
        setCurrQuestionIndex((currQuestionIndex + 1) % state.questions.length);
      }, 1000);
    } else {
      setShowErrorMessage(true);
      handlePlay();
      const scoreViewEl = document.getElementById("score-view");
      if (scoreViewEl && scoreViewEl.childNodes[currIncorrectScore]) {
        scoreViewEl.childNodes[currIncorrectScore].classList.add("red");
      }
      
      const lightEl = document.getElementById("light");
      if (lightEl) lightEl.style.backgroundColor = RED;
      
      const questionDivEl = document.getElementById("question-div");
      if (questionDivEl) questionDivEl.style.display = "none";
      
      setCurrIncorrectScore(currIncorrectScore + 1);
      // Incorrect answer but game not over; pause on red light before next question
      if (user) {
        updateProgress(user.email, unit.unit, unit.textbook, "redlightgreenlight", false);
      }
      if (audioRefBgm.current) audioRefBgm.current.pause();

      setTimeout(() => {
        setShowErrorMessage(false);
        if (currIncorrectScore === 2) {
          const gameDivEl = document.getElementById("game-div");
          const postgameDivEl = document.getElementById("postgame-div");
          const loseTextEl = document.getElementById("lose-text");
          if (gameDivEl) gameDivEl.style.display = "none";
          if (postgameDivEl) postgameDivEl.style.display = "flex";
          if (loseTextEl) loseTextEl.style.display = "flex";
          if (audioRefBgm.current) audioRefBgm.current.pause();
        } else {
          if (audioRefBgm.current) {
            audioRefBgm.current.currentTime = 0;
            audioRefBgm.current.play().catch((err) => console.log("Audio autoplay blocked:", err));
          }
        }
        handlePause();
        const lightEl = document.getElementById("light");
        if (lightEl) lightEl.style.backgroundColor = GREEN;
        setCurrQuestionIndex((currQuestionIndex + 1) % state.questions.length);
        const questionDivEl = document.getElementById("question-div");
        if (questionDivEl) questionDivEl.style.display = "flex";
      }, RED_LIGHT_PAUSE_TIME);
    }
  }

  //   console.log(questions[currQuestionIndex]);

  if (loading || state.questions.length === 0) {
    return (
      <div className="loading-screen">
        <h2>Loading vocabulary questions...</h2>
      </div>
    );
  }

  // Show error message if data fetch failed
  if (error) {
    return (
      <div className="error-screen">
        <h2>Error loading vocabulary questions: {error}</h2>
      </div>
    );
  }

  return (
    <div className="rlgl-full-container">
      <audio 
        ref={audioRefBgm} 
        src={audiobgm} 
        loop 
      />
      <AudioControls 
        volume={volume} 
        setVolume={setVolume} 
        isMuted={isMuted} 
        setIsMuted={setIsMuted} 
      />
      <video id="video" autoplay muted loop ref={videoRef}>
        <source src={video} type="video/mp4" />
        Your browser does not support video.
      </video>
      <img
        className="background-image"
        src={RedLightGreenLightImage}
        alt="Red Light Green Light"
      />
      {/* in case the video doesnt work ^ */}
      <div className="empty-div"></div>

      <div className="red-light-green-light-container">
        {/* {console.log("rerender")} */}

        <div id="header">
          <button
            type="button"
            id="rlgl-help-button"
            className="rlgl-help-button"
            onClick={openTutorial}
            aria-label="Open Red Light Green Light tutorial"
          >
            ?
          </button>
          <h1>{unit.name}</h1>
          <div id="pregame-div">
            <div id="settings-div">
              <b>Difficulty Level:</b>
              <input
                type="radio"
                id="easy"
                name="difficulty"
                value="easy"
              ></input>
              <label for="easy">Easy</label>
              <input
                type="radio"
                id="medium"
                name="difficulty"
                value="medium"
              ></input>
              <label for="medium">Medium</label>
              <input
                type="radio"
                id="hard"
                name="difficulty"
                value="hard"
              ></input>
              <label for="hard">Hard</label>
            </div>
            <br></br>
            <div id="settings-div">
              <b>Answer Language:</b>
              <input
                type="radio"
                id="korean"
                name="answer-language"
                value="korean"
              ></input>
              <label for="korean">Korean</label>
              <input
                type="radio"
                id="english"
                name="answer-language"
                value="english"
              ></input>
              <label for="english">English</label>
            </div>
            <button className="btn btn-primary" onClick={startGame}>
              Start Game
            </button>
          </div>
          <div id="game-div">
            <button id="light"></button>
            <div id="score-view">
              <ScoreView />
            </div>
            {showErrorMessage && (
              <div id="error">
                <h2 id="error-message">Incorrect answer!</h2>
                <h3 id="error-message">
                  The right answer is :{" "}
                  {Array.isArray(
                    state.questions[currQuestionIndex][answerLanguage]
                  )
                    ? state.questions[currQuestionIndex][answerLanguage].map(
                        (item, idx) => <li key={idx}>{item}</li>
                      )
                    : state.questions[currQuestionIndex][answerLanguage]}
                </h3>
              </div>
            )}
            {showCorrectMessage && (
              <div id="correct">
                <h2 id="correct-message">Correct answer! Good job!</h2>
              </div>
            )}
            <div id="question-div">
              <h4>Question:</h4>
              <h2>
                What is{" "}
                <span id="question-text">
                  {answerLanguage === "korean" ? (
                    <img
                      src={`${API_BASE_URL}/${state.questions[currQuestionIndex].imgPath}`}
                      width="180"
                      height="200"
                    />
                  ) : (
                    state.questions[currQuestionIndex].korean
                  )}
                </span>{" "}
                in {answerLanguage === "korean" ? "Korean" : "English"}?
              </h2>
              <div id="answer-div">
                <input
                  id="answer-input"
                  type="text"
                  autoComplete="off"
                  onKeyDown={(event) => {
                    if (event.key === "Enter") submitAnswer();
                  }}
                />
                <button
                  className="btn btn-primary"
                  onClick={() => {
                    submitAnswer();
                  }}
                >
                  Submit
                </button>
              </div>
            </div>
          </div>
          <div id="postgame-div">
            <h2 id="win-text">You win!</h2>
            <h2 id="lose-text">You lose!</h2>
            <button className="btn btn-primary" onClick={playAgain}>
              Play Again
            </button>
          </div>
          <div id="tutorial">
          <h2>Red Light, Green Light Tutorial</h2>
          <p>
            <b>Goal:</b> Reach 5 correct answers before the red lights cost you
            all 3 lives.
          </p>
          <p>
            <b>How to Play:</b>
            <br />
            1. Choose a difficulty level and answer language.
            <br />
            2. Read the prompt on the screen.
            <br />
            3. Type the matching translation and submit before time runs out.
            <br />
            4. Keep moving through questions until you win or lose.
          </p>
          <p>
            <b>Rules:</b>
            <br />
            A correct answer keeps you safe and moves you forward.
            <br />
            A wrong answer or running out of time turns the light red and costs
            one life.
            <br />
            Lose all 3 lives and the round ends.
          </p>
          <p>
            <b>Difficulty:</b>
            <br />
            Easy gives the longest answer time.
            <br />
            Medium gives less time.
            <br />
            Hard gives the shortest time and is the fastest round.
          </p>
            <button className="btn btn-primary" onClick={closeTutorial}>
              Back to Game Setup
            </button>
          </div>
        </div>
        <Link
          to={GAME_OPTIONS_PATH}
          state={{ unit: unit, category: category }}
          className="game-options-back-link"
        >
          <button className="btn btn-back game-options-back-button">{"Back"}</button>
        </Link>
      </div>
    </div>
  );
}

export default RedLightGreenLightPage;
